import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import type { Deliverable } from '../../types/portal';
import { formatEditStamp } from '../../utils/time';
import { BUTTON_QUIET } from './adminStyles';

/**
 * Saved transcript states, newest first. Client edits never destroy what came
 * before, so Portal can always put an earlier version back.
 */
export function TranscriptRevisions({
  deliverable
}: {
  deliverable: Deliverable;
}) {
  const {
    restoreTranscriptRevision,
    notify
  } = usePortal();
  const revisions = deliverable.transcriptRevisions ?? [];
  if (revisions.length < 2) return null;
  const ordered = [...revisions].reverse();
  return <div className="mt-12" data-id="element-362" data-mp="10o6ra56dbyg">
      <h4 className="label border-b border-ruleDark pb-4 text-paper/40" data-id="element-363" data-mp="5xen7ykw69ke">Saved Transcripts</h4>
      <ul className="m-0 list-none p-0" data-id="element-364" data-mp="ax10u94mtrtq">
        {ordered.map((revision, index) => <li key={revision.id} className="flex flex-wrap items-baseline justify-between gap-4 border-b border-ruleDark py-5" data-id="element-365" data-mp="eychvq9fx4qb" data-mpi={index}>
            <span className="min-w-0" data-id="element-366" data-mp="1vdi6mkgcebvf">
              <span className="label block text-paper/70" data-id="element-367" data-mp="1qcu8letp4urp">
                {revision.editorName}
                {index === 0 ? ' · Current' : ''}
              </span>
              <span className="label-sm mt-2 block text-paper/30" data-id="element-368" data-mp="1ldzom9jzt060">
                {formatEditStamp(revision.at)}
                {index === ordered.length - 1 ? ' · Original upload' : ''}
              </span>
            </span>
            {index > 0 && <button type="button" onClick={() => {
          restoreTranscriptRevision(deliverable.id, revision.id);
          notify(`Transcript restored · ${revision.editorName}`);
        }} className={BUTTON_QUIET} data-id="element-369" data-mp="29323xar5mgxc">
                Restore
              </button>}
          </li>)}
      </ul>
    </div>;
}